import { PaymentsFormData } from './types';

export const gatewayOptions = [
  { id: 'payConex', name: 'PayConex' },
  { id: 'payConexPlus', name: 'PayConex Plus' }
];

export const LOCKED_FIELD_KEYS: (keyof PaymentsFormData)[] = [
  'kisIsMerchant',
  'customerIsMerchant',
  'gateway',
  'isLive',
  'accountId',
  'apiKeyId',
  'apiKeySecret',
  'apiAccessKey',
  'terminalId',
  'secretKey',
  'apiKey'
];
